var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 862,
    height: 136,
    viewBox: "0 0 862 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.94 0C123.52 0 131.77 45.94 135.3 65.56C136.52 72.34 132.01 78.82 125.23 80.04C118.46 81.26 111.97 76.75 110.75 69.97C105.5 40.77 97.29 24.94 68.94 24.94C38.93 24.94 24.94 50.49 24.94 67.76C24.94 90.49 44.94 110.43 67.75 110.43C74.64 110.43 80.22 116.01 80.22 122.9C80.22 129.79 74.64 135.37 67.75 135.37C31.03 135.37 0 104.41 0 67.76C0 35.17 26.36 0 68.94 0Z",
    fill: "url(#paint0_linear_3_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.03 135.37C122.45 135.37 114.2 89.43 110.67 69.81C109.45 63.03 113.96 56.55 120.74 55.33C127.51 54.11 134 58.62 135.22 65.4C140.47 94.6 148.68 110.43 177.03 110.43C207.04 110.43 221.03 84.88 221.03 67.61C221.03 44.88 201.03 24.94 178.22 24.94C171.33 24.94 165.75 19.36 165.75 12.47C165.75 5.58 171.33 0 178.22 0C214.94 0 245.97 30.96 245.97 67.61C245.97 100.2 219.61 135.37 177.03 135.37Z",
    fill: "url(#paint1_linear_3_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.56 110.31C173.49 110.31 173.42 110.31 173.35 110.3C172.87 110.26 172.39 110.22 171.85 110.17C171.52 110.14 171.18 110.11 170.87 110.07C169.39 109.91 167.73 109.7 165.9 109.4C168.26 109.87 170.81 110.18 173.56 110.32V110.31Z",
    fill: "#00AEAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.73 25.08H72.75C73.23 25.12 73.71 25.16 74.25 25.21C74.58 25.24 74.92 25.27 75.24 25.32C76.56 25.46 78.05 25.66 79.65 25.91C77.5 25.5 75.19 25.23 72.72 25.09L72.73 25.08Z",
    fill: "#00AEAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.75 24.88C69 24.88 70.16 24.91 71.27 24.97C69.03 24.84 67.75 24.88 67.75 24.88Z",
    fill: "#00AEAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.36 110.49C177.11 110.49 175.95 110.46 174.84 110.4C177.08 110.53 178.36 110.49 178.36 110.49Z",
    fill: "#00AEAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.9 109.39C146.49 105.51 139.76 90.5 135.29 65.8C135.28 65.72 135.29 65.64 135.27 65.55C134.57 61.67 133.68 56.74 132.29 51.35C113.37 33.77 92.4099 27.87 79.6599 25.89C99.3599 29.65 106.14 44.7 110.65 69.56C110.66 69.64 110.65 69.72 110.67 69.8C111.35 73.61 112.22 78.41 113.57 83.68L113.79 83.96C132.44 101.3 153.1 107.3 165.91 109.37L165.9 109.39Z",
    fill: "#00AEAD"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.56 110.31C173.49 110.31 173.42 110.31 173.35 110.3C172.87 110.26 172.39 110.22 171.85 110.17C171.52 110.14 171.18 110.11 170.87 110.07C169.39 109.91 167.73 109.7 165.9 109.4C168.26 109.87 170.81 110.18 173.56 110.32V110.31Z",
    fill: "url(#paint2_linear_3_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.73 25.08H72.75C73.23 25.12 73.71 25.16 74.25 25.21C74.58 25.24 74.92 25.27 75.24 25.32C76.56 25.46 78.05 25.66 79.65 25.91C77.5 25.5 75.19 25.23 72.72 25.09L72.73 25.08Z",
    fill: "url(#paint3_linear_3_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.75 24.88C69 24.88 70.16 24.91 71.27 24.97C69.03 24.84 67.75 24.88 67.75 24.88Z",
    fill: "url(#paint4_linear_3_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.36 110.49C177.11 110.49 175.95 110.46 174.84 110.4C177.08 110.53 178.36 110.49 178.36 110.49Z",
    fill: "url(#paint5_linear_3_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.9 109.39C146.49 105.51 139.76 90.5 135.29 65.8C135.28 65.72 135.29 65.64 135.27 65.55C134.57 61.67 133.68 56.74 132.29 51.35C113.37 33.77 92.4099 27.87 79.6599 25.89C99.3599 29.65 106.14 44.7 110.65 69.56C110.66 69.64 110.65 69.72 110.67 69.8C111.35 73.61 112.22 78.41 113.57 83.68L113.79 83.96C132.44 101.3 153.1 107.3 165.91 109.37L165.9 109.39Z",
    fill: "url(#paint6_linear_3_19)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M354.97 51.98C352.05 47.96 346.76 46.22 342.26 46.22C330.74 46.22 322.93 55.14 322.93 66.66C322.93 78.81 330.35 87.26 341.87 87.26C347.87 87.26 352.6 84.66 355.44 80.79L363.41 86.39C358.52 92.55 351.26 96.18 341.79 96.18C324.35 96.18 311.96 84.1 311.96 66.66C311.96 49.22 325.06 37.46 342.26 37.46C349.52 37.46 358.12 40.14 362.54 45.98L354.97 51.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.22 78.81H375.41C375.81 84.18 380.7 88.12 386.22 88.12C390.96 88.12 394.11 86.23 396.24 83.23L402.55 88.28C398.84 93.33 393.47 95.86 386.29 95.86C374.61 95.86 365.93 88.36 365.93 76.05C365.93 63.74 374.53 55.77 385.97 55.77C396.55 55.77 404.28 62.64 404.28 76.29C404.3 77.16 404.3 77.95 404.22 78.81ZM394.83 72.03C394.83 67.14 392.07 62.88 385.91 62.88C380.31 62.88 375.81 66.75 375.41 72.03H394.83Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.61 35.09H423.08V94.75H413.61V35.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.76 35.09H444.23V94.75H434.76V35.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.32 94.76H481.32V88.68H481.16C479.5 92.47 475 95.86 469.4 95.86C459.53 95.86 455.43 88.28 455.43 80.55V56.87H464.9V77.86C464.9 82.36 465.93 87.96 472 87.96C478.07 87.96 480.84 82.75 480.84 77.7V56.87H490.31V94.76H490.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.85 35.09H511.32V94.75H501.85V35.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.36 89.94H546.12C544.23 93.26 539.73 95.7 534.36 95.7C528.28 95.7 520.15 92.78 520.15 83.94C520.15 72.65 534.36 71.08 546.19 71.08V70.13C546.19 65.47 542.24 63.18 537.51 63.18C533.48 63.18 529.62 65.07 527.17 67.52L522.28 61.76C526.54 57.81 532.54 55.76 538.3 55.76C551.87 55.76 555.19 64.13 555.19 71.7V94.74H546.35V89.94H546.36ZM546.2 77.47H544.07C538.07 77.47 529.63 78.18 529.63 83.78C529.63 87.41 533.02 88.52 536.26 88.52C542.73 88.52 546.2 84.81 546.2 78.81V77.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.25 56.87H575.33V63.19H575.49C577.54 58.85 581.57 55.77 586.54 55.77C587.25 55.77 588.2 55.85 588.83 56.01V64.69C587.57 64.37 586.78 64.3 585.91 64.3C577.39 64.3 575.73 71.72 575.73 74.48V94.76H566.26V56.87H566.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.18 38.88H634.99C649.59 38.88 665.85 45.82 665.85 66.82C665.85 86.39 649.59 94.76 634.99 94.76H615.18V38.88ZM633.41 86.07C643.67 86.07 655.19 81.89 655.19 66.81C655.19 50.79 643.67 47.4 633.41 47.4H625.12V86.07H633.41Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.07 78.81H682.26C682.65 84.18 687.55 88.12 693.07 88.12C697.8 88.12 700.96 86.23 703.09 83.23L709.4 88.28C705.69 93.33 700.32 95.86 693.14 95.86C681.46 95.86 672.78 88.36 672.78 76.05C672.78 63.74 681.38 55.77 692.82 55.77C703.4 55.77 711.13 62.64 711.13 76.29C711.15 77.16 711.15 77.95 711.07 78.81ZM701.68 72.03C701.68 67.14 698.92 62.88 692.76 62.88C687.16 62.88 682.66 66.75 682.26 72.03H701.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.06 66.98C739.4 64.77 736.25 62.88 732.77 62.88C729.77 62.88 726.69 63.98 726.69 66.98C726.69 69.98 729.61 70.69 734.9 71.95C740.5 73.29 747.13 75.82 747.13 83.24C747.13 92.47 739.63 95.87 731.35 95.87C725.51 95.87 719.43 93.66 715.8 89.64L722.03 83.8C724.08 86.48 727.63 88.54 731.74 88.54C734.5 88.54 737.82 87.43 737.82 84.04C737.82 80.88 734.9 79.94 729.14 78.59C723.54 77.25 717.93 74.96 717.93 67.86C717.93 59.42 725.51 55.79 733 55.79C738.45 55.79 744.13 57.68 747.21 61.55L741.06 66.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.16 38.33C763.63 38.33 766.32 40.78 766.32 44.01C766.32 47.24 763.64 49.69 760.16 49.69C756.68 49.69 754.16 47.01 754.16 44.01C754.16 41.01 756.68 38.33 760.16 38.33ZM755.5 56.87H764.97V94.75H755.5V56.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.01 56.87V91.36C815.01 105.01 808.38 113.69 793.62 113.69C787.46 113.69 779.73 111.48 774.84 107.46L780.29 100.12C783.92 103.59 788.81 105.49 793.55 105.49C802.7 105.49 805.55 99.97 805.55 92.47V89.71H805.39C802.63 93.42 798.21 95.39 793 95.39C781.64 95.39 774.3 86.39 774.3 75.66C774.3 64.93 781.4 55.77 792.85 55.77C798.14 55.77 803.11 57.98 805.87 62.56H806.03V56.88H815.01V56.87ZM783.91 75.58C783.91 81.58 787.93 87.58 794.72 87.58C801.51 87.58 806.01 81.9 806.01 75.58C806.01 69.26 801.67 63.5 794.8 63.5C787.93 63.5 783.91 68.87 783.91 75.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.37 56.87H835.37V62.95H835.53C837.19 59.16 841.69 55.77 847.29 55.77C857.15 55.77 861.26 63.35 861.26 71.08V94.76H851.79V73.76C851.79 69.26 850.76 63.66 844.69 63.66C838.62 63.66 835.85 68.87 835.85 73.92V94.75H826.38V56.87H826.37Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_19",
    x1: 135.49,
    y1: 67.69,
    x2: 0,
    y2: 67.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_19",
    x1: 110.47,
    y1: 67.69,
    x2: 245.96,
    y2: 67.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_19",
    x1: 165.9,
    y1: 109.85,
    x2: 173.56,
    y2: 109.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_19",
    x1: 72.73,
    y1: 25.49,
    x2: 79.66,
    y2: 25.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_19",
    x1: 67.75,
    y1: 24.93,
    x2: 71.26,
    y2: 24.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3_19",
    x1: 174.85,
    y1: 110.45,
    x2: 178.36,
    y2: 110.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3_19",
    x1: 122.78,
    y1: 107.29,
    x2: 122.78,
    y2: 28.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7D7D7D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 861.26,
    height: 135.37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.2f81ce138f53f2f4b57827ed1902a895.svg";
export { ForwardRef as ReactComponent };